import libphonenumberUtilsSource from "libphonenumber-js-utils/dist/libphonenumber.js?raw";

if (!window.intlTelInputUtils && libphonenumberUtilsSource) {
    const script = document.createElement("script");
    script.textContent = libphonenumberUtilsSource;
    document.head.appendChild(script);
    script.remove();
}
